import { isSweepstakesQuery } from '@gig/magic-common';
import { USER_JURISDICTION_QUERY, COUNTRY_JURISDICTION_QUERY, USER_UPDATED, USER_JURISDICTION_UPDATED, IP_COUNTRY_QUERY, USER_PROFILE_DATA } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';
import { Jurisdiction } from '@gig/magic-jurisdictions/dist/jurisdictions.constants';
import { JurisdictionCommonService } from './jurisdiction.utils.js';

var JurisdictionCoreXService = /** @class */ (function () {
    function JurisdictionCoreXService(countryToJurisdiction, defaultJurisdiction) {
        this.service = new JurisdictionCommonService(countryToJurisdiction, defaultJurisdiction);
        this.registerJurisdictionEvents();
        this.registerJurisdictionQuery();
        this.registerJurisdictionChanges();
    }
    JurisdictionCoreXService.prototype.registerJurisdictionQuery = function () {
        var _this = this;
        window.queryBus.subscribe(USER_JURISDICTION_QUERY, function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getJurisdiction()];
            });
        }); });
        window.queryBus.subscribe(COUNTRY_JURISDICTION_QUERY, function (event) { return __awaiter(_this, void 0, void 0, function () {
            var isSweepstakes, country;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, isSweepstakesQuery()];
                    case 1:
                        isSweepstakes = _a.sent();
                        if (isSweepstakes) {
                            return [2 /*return*/, Jurisdiction.SWEEPSTAKES];
                        }
                        country = event.payload;
                        return [2 /*return*/, this.service.getJurisdictionByCountry(country)];
                }
            });
        }); });
    };
    JurisdictionCoreXService.prototype.registerJurisdictionChanges = function () {
        var _this = this;
        window.eventBus.subscribe(USER_UPDATED, function () { return __awaiter(_this, void 0, void 0, function () {
            var jurisdiction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getJurisdiction()];
                    case 1:
                        jurisdiction = _a.sent();
                        window.eventBus.publish(USER_JURISDICTION_UPDATED, jurisdiction);
                        return [2 /*return*/];
                }
            });
        }); }, { replay: true });
    };
    JurisdictionCoreXService.prototype.getJurisdiction = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isSweepstakes, user, jurisdiction, config, country;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, isSweepstakesQuery()];
                    case 1:
                        isSweepstakes = _a.sent();
                        if (isSweepstakes) {
                            return [2 /*return*/, Jurisdiction.SWEEPSTAKES];
                        }
                        return [4 /*yield*/, window.queryBus.query(USER_PROFILE_DATA)];
                    case 2:
                        user = _a.sent();
                        if (!user) return [3 /*break*/, 4];
                        jurisdiction = user.jurisdictionCode.toUpperCase();
                        return [4 /*yield*/, this.service.getCountryMap()];
                    case 3:
                        config = _a.sent();
                        if (Object.values(config).includes(jurisdiction)) {
                            return [2 /*return*/, jurisdiction];
                        }
                        return [2 /*return*/, this.service.defaultJurisdiction];
                    case 4: return [4 /*yield*/, window.queryBus.query(IP_COUNTRY_QUERY)];
                    case 5:
                        country = _a.sent();
                        return [2 /*return*/, this.service.getJurisdictionByCountry(country)];
                }
            });
        });
    };
    JurisdictionCoreXService.prototype.registerJurisdictionEvents = function () {
        window.eventBus.register(USER_JURISDICTION_UPDATED, {
            type: 'string',
            enum: Object.values(Jurisdiction),
        });
    };
    return JurisdictionCoreXService;
}());

export { JurisdictionCoreXService };
